import React from 'react';
import { COLORS, Color } from '../../styles/variables';

interface EDepositCloseIconProps {
  color?: Color;
  size?: number;
}

const EDepositCloseIcon: React.FC<EDepositCloseIconProps> = ({
  color = COLORS.black,
  size = 15,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.002L12.2 12.198M1.002 12.2L12.198 1L1.002 12.2Z"
      stroke={color}
      strokeMiterlimit="10"
    />
  </svg>
);

EDepositCloseIcon.defaultProps = {
  color: COLORS.black,
  size: 12,
};

export default EDepositCloseIcon;
